import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { ContactCreditTable } from "@/app/ContactCredits/Components/ContactCreditTable";
import { ContactCreditBalances } from "@/app/ContactCredits/Components/ContactCreditBalances";
import { IssueContactCreditButton } from "@/app/ContactCredits/Components/IssueContactCreditButton";

export function ContactCreditsScreen() {
  const record = useContactRecord();

  return (
    <div className="space-y-12 py-6">
      <RecordScreenCard
        title="Credit balance"
        subtitle="Credit comes off the next invoice raised in the same currency"
        buttons={<IssueContactCreditButton contactId={record.id} />}
      >
        <ContactCreditBalances contactId={record.id} />
      </RecordScreenCard>
      <RecordScreenCard title="Ledger">
        <ContactCreditTable
          id="contact-credits"
          queryVariables={{
            contactId: record.id,
          }}
        />
      </RecordScreenCard>
    </div>
  );
}
